import React from 'react';
import ReactDOM from 'react-dom/client';
import 'index.css';
import FloatingToast from 'FloatingToast';
import 'themes/colors.css';
import 'themes/grid.css';
import 'themes/fontStyles.css';
import { Navbar } from 'components/navbar/Navbar';
import { Home } from 'pages/home/Home';
import { ContactUs } from 'pages/contactUs/ContactUs';
import { OurStory } from 'pages/ourStory/OurStory';
import reportWebVitals from './reportWebVitals';
import { Routes, Route, BrowserRouter } from "react-router-dom";
// import ComingSoon from 'pages/comingSoon/ComingSoon';
import { Quiz } from 'pages/quiz/Quiz';
import { Blog } from 'pages/blog/Blog';
import { BlogPostPage } from 'pages/blog/BlogPostPage';
import { Features } from 'pages/features/Features';
import { FeaturePostPage } from 'pages/features/FeaturePostPage';
import { Changelog } from 'pages/features/changelog/Changelog';
import { FeatureVoting } from 'pages/features/voting/FeatureVoting';
import { Footer } from 'components/footer/Footer';
import { PrivacyPolicy } from 'pages/privacyPolicy/PrivacyPolicy';
import { TermsOfUse } from 'pages/termsOfUse/TermsOfUse';
import { Redeem } from 'pages/redeem/Redeem';
import { Gift } from 'pages/gift/Gift';
import { GiftThanks } from 'pages/gift/GiftThanks';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { organizationJsonLd, websiteJsonLd } from 'components/seo/organizationSchema';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function App() {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      </Helmet>
      <div className="app-wrapper">
        <FloatingToast />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          <Route path="/features" element={<Features />} />
          <Route path="/features/changelog" element={<Changelog />} />
          {/* Feature voting is dev-only until it's built */}
          {process.env.NODE_ENV === 'development' && (
            <Route path="/features/vote" element={<FeatureVoting />} />
          )}
          <Route path="/features/:id" element={<FeaturePostPage />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/redeem" element={<Redeem />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/gift/thanks" element={<GiftThanks />} />
        </Routes>
      </div>
      <Footer />
    </>
  )
}

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
